import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import BasicDetailRow from 'components/basicDetailRow';
import { ISSUE_TYPE_RELEASE } from 'constants/project';

const IssueDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <BasicDetailRow label={<IntlMessages id="label.description" />} description={displayData?.description} />
                    <BasicDetailRow label={<IntlMessages id="label.type" />} description={displayData?.type} />
                    <BasicDetailRow label={<IntlMessages id="label.assignee" />} description={displayData?.assignee} />
                    <BasicDetailRow label={<IntlMessages id="label.feature" />} description={displayData?.feature} />
                    <BasicDetailRow label={<IntlMessages id="label.startDate" />} description={displayData?.startDate} />
                    <BasicDetailRow label={<IntlMessages id="label.endDate" />} description={displayData?.endDate} />
                    {displayData?.type === ISSUE_TYPE_RELEASE
                        ?
                        <Fragment>
                            <BasicDetailRow label={<IntlMessages id="label.releaseEnv" />} description={displayData?.releaseEnv} />
                            <BasicDetailRow label={<IntlMessages id="label.releaseDate" />} description={displayData?.releaseDate} />
                            <BasicDetailRow label={<IntlMessages id="label.releaseCutoffDate" />} description={displayData?.releaseCutoffDate} />
                            <BasicDetailRow label={<IntlMessages id="label.releaseVersion" />} description={displayData?.releaseVersion} />
                        </Fragment>
                        : null
                    }
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default IssueDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/issue/issueDetail/issueDetailTable/index.js